/**
 * 
 * Nav.js
 * 
 */
export default class Nav {

    constructor() {
        this.name = 'Nav';
        this.siteContent            = document.querySelector('.site');
        this.header                 = document.querySelector('.header');
        this.siteContentCover       = document.querySelector('.page-cover');
        this.slideMenuBtn           = document.querySelector('.slide-menu');
        this.slideMenuCloseBtn      = document.querySelector('.menu-close-btn');
        this.slideMenuCloseBtnBG    = new Image();
        this.menuToSlide            = this.slideMenuBtn.querySelector('.sub-menu');
        this.menuWidth              = this.menuToSlide.offsetWidth;
        this.menuOpen               = false;
        this.isReset                = true;
        this.enabled                = true;
        this.themePath              = '/wp-content/themes/smokehousemarket/';

        this._init();
    }

    // Public Functions
    resetMenu () {
        //console.log('Nav.js: resetMenu()');
        if (this.menuOpen) {
            this._toggleSlideMenu();
        }
        this.isReset = true;
    }

    enable () {
        this.enabled = true;
    }

    disable () {
        this.enabled = false;
    }

    // Getters / Setters
    get reset() {
        return this.isReset;
    }

    set reset($val) {
        this.isReset = $val;
    }
    
    // 'Private' Functions
    _init() {
        this.slideMenuCloseBtnBG.src = this.themePath + 'img/close-btn-x.svg';
        this.slideMenuCloseBtnBG.setAttribute('class', 'svg');
        this.slideMenuCloseBtn.appendChild(this.slideMenuCloseBtnBG);
        //console.log('Nav.js: this.menuWidth', this.menuWidth);
        this.slideMenuBtn.addEventListener('click', (e) => {
            if (e.target.tagName.toLowerCase() === 'a') {
                this._toggleSlideMenu();
            }
        });
        
        this.siteContentCover.addEventListener('click', () => {
            this._toggleSlideMenu();
        });
        
        this.slideMenuCloseBtn.addEventListener('click', () => {
            this._toggleSlideMenu();
        });

        // Scroll listener: Close menu if user scrolls down the page past a certain point
        window.addEventListener('scroll', () => this._onPageScroll());
    }

    _toggleSlideMenu() {
        //console.log('Nav: _toggleSlideMenu');
        if (this.enabled) {
            this.menuWidth = this.menuToSlide.offsetWidth;
    
            if (!this.menuOpen) {
                this.menuOpen = true;
                this.isReset = false;
                this.siteContent.style.transform = `translateX(${-this.menuWidth}px)`;
                this.header.style.transform = `translateX(${-this.menuWidth}px)`;
                this.siteContentCover.style.transform = `translateX(${-this.menuWidth}px)`;
                this.siteContentCover.classList.add('fadein');
                this.siteContentCover.classList.remove('fadeout');
            } else {
                this.menuOpen = false;
                this.siteContent.style.transform = 'translateX(0px)';
                this.header.style.transform = 'translateX(0px)';
                this.siteContentCover.style.transform = 'translateX(0px)';
                this.siteContentCover.classList.remove('fadein');
                this.siteContentCover.classList.add('fadeout');
    
                this.siteContentCover.addEventListener('transitionend', () => {
                    this.siteContentCover.classList.remove('fadeout');
                });
            }
        }
    }

    _onPageScroll() {
        if (this.enabled) {
            if (window.scrollY > 130 && this.menuOpen) {
                this._toggleSlideMenu();
            }
        }
    }
}
